import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import SharedPhysicalProperties from '../../../../components/Forms/PhysicalProperties/SharedPhysicalProperties'
import TabWrapper, { TabItem } from '../../../../components/TabWrapper/TabWrapper'
import PhysicalProperties from '../../../shared/PhysicalProperties'
import { messages } from './messages'
import PriceDetails from './PriceDetails'
import ProductDetails from './ProductDetails'
import Temperature from './Temperature'

interface ProductFormTabsProps {
  isDisabled?: boolean
  customerId?: number
}

const ProductFormTabs = ({ isDisabled = false, customerId = -1 }: ProductFormTabsProps) => {
  const { formatMessage } = useIntl()
  const {
    formState: { errors },
  } = useFormContext()

  const hasProductDetailsErrors = !!(
    errors.name ||
    errors.sku ||
    errors.productCategoryId ||
    errors.countryOfOriginId ||
    errors.barcode ||
    errors.customerId ||
    errors.inventoryUnitId
  )

  const hasPriceDetailsErrors = !!errors.prices

  const hasPhysicalPropertiesErrors = !!errors.physicalProperties

  const hasTemperatureErrors = !!errors.temperatureSetting

  const tabs: TabItem[] = useMemo(() => [
    {
      label: formatMessage(messages.productDetails),
      content: <ProductDetails isDisabled={isDisabled} customerId={customerId} />,
      hasError: hasProductDetailsErrors,
    },
    {
      label: formatMessage(messages.priceDetails),
      content: <PriceDetails isViewMode={isDisabled} customerId={customerId} />,
      hasError: hasPriceDetailsErrors,
    },
    {
      label: formatMessage(messages.physicalProperties),
      content: <SharedPhysicalProperties variant='product' isDisabled={isDisabled} />,
      hasError: hasPhysicalPropertiesErrors,
    },
    {
      label: formatMessage(messages.temperature),
      content: <Temperature isDisabled={isDisabled} customerId={customerId} />,
      hasError: hasTemperatureErrors,
    },
  ], [formatMessage, isDisabled, customerId, hasProductDetailsErrors, hasPriceDetailsErrors, hasPhysicalPropertiesErrors, hasTemperatureErrors])

  return <TabWrapper tabs={tabs} variant='standard' />
}

export default ProductFormTabs
